import { render, staticRenderFns } from "./DictModal.vue?vue&type=template&id=448264c2&"
import script from "./DictModal.vue?vue&type=script&lang=js&"
export * from "./DictModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports